import { render, staticRenderFns } from "./AppTaskDoneDialog.vue?vue&type=template&id=f51104d8&"
import script from "./AppTaskDoneDialog.vue?vue&type=script&lang=js&"
export * from "./AppTaskDoneDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports